module.exports = __webpack_public_path__ + "media/EnergiaTermoelectrica.9f44dbc2.mp4";